
	var HistEntry = function( c ){
		this.col = c;
		this.freq = 1;
	};

	HistEntry.prototype = {
		constructor: HistEntry,
		compareTo: function( entry ){
			return parseInt( entry.freq - this.freq, 10 );
		},
		getColor: function(){
			return this.col;
		},
		getFrequency: function(){
			return this.freq;
		}
	};
	module.exports = HistEntry;



//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/color/HistEntry.js
// module id = 3083
// module chunks = 13